//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function loadReportService(idGroup, startDateFilter, endDateFilter) {
    try {
        if (!idGroup || !startDateFilter || !endDateFilter) {
            return null;
        }
        const response = await api.get("/gastos-grupo/relatorio", {
            params: {
                grupo_id: idGroup,
                data_inicio: startDateFilter,
                data_fim: endDateFilter
            }
        });
        return response;
    } catch (err) {
        console.error("❌ Erro ao carregar relatório:", err);

        if (err.response) {
            toast.error(`Erro ${err.response.status}: ${err.response.data?.error || "Erro inesperado no servidor"}`);
            return null;
        } else if (err.request) {
            toast.error("Sem resposta do servidor. Verifique sua conexão.");
            return null;
        } else {
            toast.error(`Erro desconhecido: ${err.message}`);
            return null;
        }
    }
}